import xhr from 'xhr';
import { SERVER_ERROR } from '../constants/messages';

// the request details go in custom data, not the message, so Rollbar groups
// each kind of failure into one item rather than one per URL
function sendRollBarMessage(severity, message, error, response){
  const request = { method: response.method, url: response.url, status: response.statusCode };
  try {
    // xhr passes a null error for HTTP error statuses
    error ? Rollbar[severity](message, error, request) : Rollbar[severity](message, request);
  } catch(e){
    // Rollbar isn't loaded (no token set, or blocked)
  }
}

function handleAction(error, response, body, callbacks) {
  if (!Object.keys(callbacks).length) return;

  if (response.statusCode >= 200 && response.statusCode < 400) {
    return callbacks.onSuccess({ response, data: body });
  }

  if ( body ) {
    return callbacks.onError({ response, error: body });
  }

  // statusCode 0 means no response at all: the visitor went offline, left the
  // page, a blocker stopped the request or the connection stalled. Nothing the
  // API did, so it's a warning.
  if (response.statusCode === 0) {
    sendRollBarMessage("warning", "Network request failed", error, response);
  } else {
    sendRollBarMessage("error", "API request failed", error, response);
  }
  return callbacks.onError({ error: SERVER_ERROR, details: error });
}

function JSONParse(item){
  try {
    return JSON.parse(item);
  } catch(e) {
    return undefined;
  }
}

export function getData(url, options = {}, callbacks = {}){
  const settings = {
    json: true,
    headers: {
      ...options,
      "Content-Type": "application/json"
    }
  };

  xhr.get(url, settings, function(error, response, body){
    handleAction(error, response, body, callbacks);
  });
}

export function postData(url, options = {}, data={}, callbacks = {}){
  const settings = {
    headers: {
      ...options,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };

  xhr.post(url, settings, function(error, response, body){
    handleAction(error, response, JSONParse(body), callbacks);
  });
}

export function updateData(url, options = {}, data={}, callbacks = {}){
  const settings = {
    json: true,
    headers: {
      ...options,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };

  xhr.put(url, settings, function(error, response, body){
    handleAction(error, response, JSONParse(body), callbacks);
  });
}

export function deleteData(url, options = {}, data={}, callbacks = {}){
  const settings = {
    headers: {
      ...options,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };

  xhr.del(url, settings, function(error, response, body){
    handleAction(error, response, JSONParse(body), callbacks);
  });
}

export function patchData(url, options = {}, data={}, callbacks = {}){
  const settings = {
    headers: {
      ...options,
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  };

  xhr.patch(url, settings, function(error, response, body){
    handleAction(error, response, JSONParse(body), callbacks);
  });
}
